import { render, staticRenderFns } from "./InstitutionDetails.vue?vue&type=template&id=43911a54&scoped=true&"
import script from "./InstitutionDetails.vue?vue&type=script&lang=js&"
export * from "./InstitutionDetails.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionDetails.vue?vue&type=style&index=0&id=43911a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43911a54",
  null
  
)

export default component.exports